export const LEGAL_AGE = 18;
export const CRYPTO_DECIMALS = 8;
export const BUNDLE_DECIMALS = 5;
export const FIAT_DECIMALS = 2;
